import React from 'react';
import logo from '../../assets/logo/logo-v-black.svg';
import styles from './styles.module.scss';

const SplashScreen = () => (
    <div className={styles.splashContainer}>
      <img src={logo} alt="accuraiser logo" className={styles.logo}/>
    </div>
);
export default SplashScreen;
